export enum PromoCodeErrorExtensions {
  // server/app/schema/promoCode.js
  PROMO_CODE_INVALID = 'PROMO_CODE_INVALID',
  PROMO_CODE_NOT_FOUND = 'PROMO_CODE_NOT_FOUND',
  PROMO_CODE_EXPIRED = 'PROMO_CODE_EXPIRED',
  PROMO_CODE_NOT_ELIGIBLE = 'PROMO_CODE_NOT_ELIGIBLE',
  PROMO_CODE_ALREADY_REDEEMED = 'PROMO_CODE_ALREADY_REDEEMED',
  PROMO_CODE_INVALID_BILLING_PERIOD = 'PROMO_CODE_INVALID_BILLING_PERIOD',
}

export const PromoCodeErrors: Record<string, PromoCodeErrorExtensions> = {
  'Code not found': PromoCodeErrorExtensions.PROMO_CODE_NOT_FOUND,
  'this code does not apply to this billing period':
    PromoCodeErrorExtensions.PROMO_CODE_INVALID_BILLING_PERIOD,
  'Your code is invalid': PromoCodeErrorExtensions.PROMO_CODE_INVALID,
  'Code was already used': PromoCodeErrorExtensions.PROMO_CODE_ALREADY_REDEEMED,
  'Code has expired': PromoCodeErrorExtensions.PROMO_CODE_EXPIRED,
  'you are already an admin of a bc team':
    PromoCodeErrorExtensions.PROMO_CODE_NOT_ELIGIBLE,
  "Can't use this promo code on this model":
    PromoCodeErrorExtensions.PROMO_CODE_NOT_ELIGIBLE,
};
